<template>
    <a
            class="tw-cursor-pointer text-danger hover:tw-text-red-dark tw-mr-6"
            v-if="roles.is_owner && ! roles.is_public"
            @click="deleteItem"
    >
        <i class="fa fa-times"></i>
    </a>
</template>

<script>
    import {mapGetters} from 'vuex';
    import deleteMixin from '../../mixins/delete';
    export default {
        name: "DeleteButton",
        mixins: [deleteMixin],
        props: ['itemId', 'type', 'message'],
        computed: {
            ...mapGetters({
                roles: 'player-profile/roles'
            })
        },
        methods: {
            deleteItem() {
                this.destroyProfileItem({
                    id: this.itemId,
                    type: this.type,
                    message: this.message
                });
            }
        }
    }
</script>
